var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add_blue_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.25h-4.5V.75a.75.75 0 00-1.5 0v4.5H.75a.75.75 0 000 1.5h4.5v4.5a.75.75 0 101.5 0v-4.5h4.5a.75.75 0 100-1.5z",
    fill: "#2355FC",
    stroke: "#2355FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add_blue_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

export default SvgAddBlue;